const isMotoGp = process.env.SITE_TYPE === 'moto-gp' || window.location.href.includes('motogp');

export default isMotoGp;
